// extracted by mini-css-extract-plugin
export default {"tooltip":"BasicTooltip_tooltip__2G7fn","tooltipArrow":"BasicTooltip_tooltipArrow__FrgXV"};